import React from 'react';
import {
  BsBarChart,
  BsClipboardCheck,
  BsGear,
  BsHouseDoor,
  BsLayoutTextWindowReverse,
  BsPeople
} from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Flex, VStack } from '@chakra-ui/react';

import { analyticsIds } from '../../constants/analyticsIds';
import { CypressIds } from '../../constants/cypressIds';
import { VIEW_ADMIN_SECTION } from '../../constants/permissions';
import { selectCurrentPage } from '../../redux/modules/app';
import { selectCompany, selectCompanyId } from '../../redux/modules/company';
import { resetError } from '../../redux/modules/error';
import { selectNavExpanded } from '../../redux/modules/navbar';
import { getContentHeightString, Nav } from '../../styles/layoutDimensions';
import colors from '../../styles/theme/foundation/colors';
import Authorizer from '../Authorizer';

import NavBarLink from './NavBarLink';

const NavBar = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector(selectCurrentPage);
  const currentCompanyId = useSelector(selectCompanyId);
  const company = useSelector(selectCompany);
  const isNavExpanded = useSelector(selectNavExpanded);

  const getVariant = pageTitle => (currentPage === pageTitle ? 'accent' : 'textGrey');

  const navWidth = isNavExpanded ? Nav.expandedWidth : Nav.collapsedWidth;
  const navLinkStyle = isNavExpanded ? 'expanded' : 'collapsed';

  return (
    <Box
      bg="white"
      display="flex"
      flexDirection="column"
      minW={navWidth}
      sx={{ minH: getContentHeightString() }}
      zIndex="500"
    >
      <Flex
        alignItems="center"
        bg="white"
        boxShadow={`inset 0 1px ${colors.greyScale['200']}`}
        color="greyScale.700"
        flexDirection="column"
        height={getContentHeightString()}
        justifyContent="space-between"
        left={0}
        position="fixed"
        pt={8}
        width={navWidth}
      >
        {company && (
          <VStack justifyContent="center" spacing={6}>
            {(currentCompanyId) && (
              <>
                <NavBarLink
                  cypressId={CypressIds.navBarHomePage}
                  dataAnalyticsId={analyticsIds.navBar.homeButton}
                  dusk={analyticsIds.navBar.homeButton}
                  icon={BsHouseDoor}
                  style={navLinkStyle}
                  title="Home"
                  to={`/companies/${currentCompanyId}/departments`}
                  variant={getVariant('list-departments')}
                  onClick={() => dispatch(resetError())}
                />
                <NavBarLink
                  cypressId={CypressIds.navBarInsuredsPage}
                  dataAnalyticsId={analyticsIds.navBar.insuredsButton}
                  dusk={analyticsIds.navBar.insuredsButton}
                  icon={BsPeople}
                  style={navLinkStyle}
                  title="Insureds"
                  to={`/companies/${currentCompanyId}/insureds`}
                  variant={getVariant('insureds')}
                  onClick={() => {
                    dispatch(resetError());
                  }}
                />
                <NavBarLink
                  cypressId={CypressIds.navBarProjectsPage}
                  dataAnalyticsId={analyticsIds.navBar.projectsButton}
                  dusk={analyticsIds.navBar.projectsButton}
                  icon={BsClipboardCheck}
                  style={navLinkStyle}
                  title="Projects"
                  to={`/companies/${currentCompanyId}/projects`}
                  variant={getVariant('projects')}
                  onClick={() => {
                    dispatch(resetError());
                  }}
                />
                <NavBarLink
                  cypressId={CypressIds.navBarReportsPage}
                  dataAnalyticsId={analyticsIds.navBar.reportsButton}
                  dusk={analyticsIds.navBar.reportsButton}
                  icon={BsBarChart}
                  style={navLinkStyle}
                  title="Reports"
                  to={`/companies/${currentCompanyId}/reports`}
                  variant={getVariant('reports')}
                  onClick={() => {
                    dispatch(resetError());
                  }}
                />
                <NavBarLink
                  cypressId={CypressIds.navBarTemplatesPage}
                  dataAnalyticsId={analyticsIds.navBar.templatesButton}
                  dusk={analyticsIds.navBar.templatesButton}
                  icon={BsLayoutTextWindowReverse}
                  style={navLinkStyle}
                  title="Templates"
                  to={`/companies/${currentCompanyId}/templates/requirement-templates`}
                  variant={getVariant('templates')}
                  onClick={() => {
                    dispatch(resetError());
                  }}
                />
              </>
            )}
            <Authorizer permission={VIEW_ADMIN_SECTION}>
              <NavBarLink
                cypressId={CypressIds.navBarAdminPage}
                dataAnalyticsId={analyticsIds.navBar.adminSettingsButton}
                dusk={analyticsIds.navBar.adminSettingsButton}
                icon={BsGear}
                style={navLinkStyle}
                title="Admin Settings"
                to={`/companies/${currentCompanyId}/admin/users`}
                variant={getVariant('admin')}
                onClick={() => {
                  dispatch(resetError());
                }}
              />
            </Authorizer>
          </VStack>
        )}
      </Flex>
    </Box>
  );
};

export default NavBar;
